// extracted by mini-css-extract-plugin
export default {"otpContainer":"OtpInput_otpContainer__nuHaH","otpInput":"OtpInput_otpInput__xaZ-J","normal":"OtpInput_normal__-rxyB","error":"OtpInput_error__sbHdY"};